import {
  ElAside,
  ElAvatar,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElButton,
  ElCascader,
  ElCheckbox,
  ElCol,
  ElContainer,
  ElDatePicker,
  ElTimePicker,
  ElDialog,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElForm,
  ElFormItem,
  ElHeader,
  ElInput,
  ElLink,
  ElMain,
  ElMenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElMessage,
  ElMessageBox,
  ElOption,
  ElPagination,
  ElRow,
  ElSelect,
  ElSelectV2,
  ElSubmenu,
  ElTable,
  ElTableColumn,
  ElTabPane,
  ElTabs,
  ElTree,
  ElNotification,
  ElCard,
  ElUpload,
  ElImage,
  ElAutocomplete,
  ElTag,
  ElDrawer,
  ElButtonGroup,
  ElImageViewer,
  ElSwitch,
  ElCollapseItem,
  ElCollapse,
  ElBadge,
  ElScrollbar,
  ElTimeline,
  ElTimelineItem,
  ElCalendar,
  ElCheckboxGroup,
  ElColorPicker,
  ElProgress,
  ElEmpty,
  ElAffix,
  ElDivider,
  ElPopover
} from 'element-plus'
import 'element-plus/lib/theme-chalk/base.css'
import { App } from 'vue'

const components = [
  ElButton,
  ElTabs,
  ElTabPane,
  ElForm,
  ElInput,
  ElFormItem,
  ElCheckbox,
  ElLink,
  ElMessage,
  ElMessageBox,
  ElContainer,
  ElMain,
  ElHeader,
  ElAside,
  ElMenu,
  ElSubmenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElRow,
  ElCol,
  ElSelect,
  ElSelectV2,
  ElOption,
  ElDatePicker,
  ElTimePicker,
  ElDropdown,
  ElAvatar,
  ElDropdownMenu,
  ElDropdownItem,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElTable,
  ElTableColumn,
  ElPagination,
  ElDialog,
  ElTree,
  ElCascader,
  ElNotification,
  ElCard,
  ElUpload,
  ElImage,
  ElAutocomplete,
  ElTag,
  ElDrawer,
  ElButtonGroup,
  ElImageViewer,
  ElSwitch,
  ElCollapseItem,
  ElCollapse,
  ElBadge,
  ElScrollbar,
  ElTimeline,
  ElTimelineItem,
  ElCalendar,
  ElCheckboxGroup,
  ElColorPicker,
  ElProgress,
  ElEmpty,
  ElAffix,
  ElDivider,
  ElPopover
]

export function registerElement(app: App): void {
  for (const component of components) {
    app.component(component.name, component)
  }
}
